<script setup lang="ts">
import {
  DropdownMenuTrigger,
  type DropdownMenuTriggerProps,
  Primitive,
  useForwardProps,
} from 'radix-vue'

const props = defineProps<DropdownMenuTriggerProps>()

const forwardedProps = useForwardProps(props)

;(DropdownMenuTrigger as any).compatConfig = { MODE: 3 }
;(Primitive as any).compatConfig = { MODE: 3 }
</script>

<script lang="ts">
export default {
  compatConfig: {
    MODE: 3,
  },
}
</script>

<template>
  <DropdownMenuTrigger
    class="outline-none"
    v-bind="forwardedProps">
    <slot />
  </DropdownMenuTrigger>
</template>
